import React, { useState, Component, useEffect } from 'react';
import { connect } from 'react-redux'
import * as actions from '@/models/orders/actions'
import cn from 'classnames';
import { Modal, Form, Button, Select, Input, Popconfirm, Radio, InputNumber, Tabs } from 'antd';
import styles from './style.module.less';
import * as apis from '@/apis'


function CancelOrder(props) {
  const { children, order, form, dispatch } = props
  const { getFieldDecorator, validateFields, getFieldValue, resetFields } = form;

  const [showDialog, toggleDialog] = useState(false);
  const [reasonList, setReasonList] = useState([]);
  const [activeKey, setActiveKey] = useState('0');

  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      // const reason = values.cancel_type + ' - ' + values.cancel_memo
      dispatch(actions.closeOrder(
        order.get('_id'),
        {
          cancel_reason: values.cancel_reason || values.cancel_type,
          // reason,
          // fee: values.cancel_fee ? values.fee : 0
        }
      ))

      toggleDialog(false)
    });
  }
  const initData = () => {
    apis.getAllReasons({ type: 'cancel' }).then(res => {
      setReasonList(res.reason || []);
    })
  }
  useEffect(() => {
    initData()
  }, [])

  return (
    <React.Fragment>
      {
        React.isValidElement(children) && React.cloneElement(children, {
          onClick: toggleDialog,
        })
      }
      <Modal
        title="取消工单"
        destroyOnClose

        width={500}
        visible={!!showDialog}
        onOk={() => { handleSubmit() }}
        onCancel={() => toggleDialog(false)}

        mask={false}
        wrapClassName="order-detail-modal-wrap"
        maskStyle={{ position: 'absolute' }}
        getContainer={() => document.getElementById('order-detail-wrap') || window}
      >
        <Form {...formItemLayout} className={styles.form}>
          <Tabs
            defaultActiveKey={activeKey}
            size="small"
            onChange={(val) => {
              setActiveKey(val)
              resetFields()
            }}>
            {
              reasonList.map((item, index) => {
                return <Tabs.TabPane tab={item.name} key={String(index)} ></Tabs.TabPane>
              })
            }
          </Tabs>
          {reasonList[activeKey]?.name != '其他原因' ?
            <Form.Item label="取消理由" width={120}>
              {getFieldDecorator('cancel_type', {
                rules: [
                  {
                    required: true,
                    message: '请选择取消理由',
                  },
                ],
              })(
                <Select placeholder="请选择取消理由">
                  {
                    reasonList[activeKey]?.list.map(reason => {
                      if (reason.groupName && reason.list) {
                        return (
                          <Select.OptGroup key={reason.groupName} label={reason.groupName}>
                            {
                              reason.list.map(reason => (
                                <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                              ))
                            }
                          </Select.OptGroup>
                        )
                      }

                      return <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                    })
                  }
                </Select>
              )}
            </Form.Item>
            :
            <Form.Item label="取消原因">
              {getFieldDecorator('cancel_reason', {
                rules: [
                  {
                    required: true,
                    message: '请输入取消原因',
                  },
                ],
              })(
                <Input.TextArea rows={4} placeholder="请输入取消原因"></Input.TextArea>
              )}
            </Form.Item>
          }


          {/* <Form.Item label="是否产生费用" extra={order.payer_type === 2 && '注意: 取消保外工单产生的费用也会由企业承担'}>
            {getFieldDecorator('cancel_fee', {
              rules: [
                {
                  required: true,
                  message: '请确认是否产生费用',
                },
              ],
            })(
              <Radio.Group>
                <Radio value={true}>已产生费用</Radio>
                <Radio value={false}>没有</Radio>
              </Radio.Group>
            )}
          </Form.Item> */}
          {
            getFieldValue('cancel_fee') && (
              <Form.Item label="费用总计" extra="请与师傅沟通已产生费用，此费用会全额给到师傅。如当前工单还未指定师傅，费用会计入平台收入">
                {getFieldDecorator('fee', {
                  rules: [
                    {
                      required: !!getFieldValue('cancel_fee'),
                      message: '请输入费用总计',
                    },
                  ],
                })(
                  <InputNumber />
                )}
              </Form.Item>
            )
          }
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default connect()(Form.create()(CancelOrder))